import React, { Component } from 'react'
import './Mag.css';

import img1 from '../assets/issue_7/RM007_COVER1_FORPRINT_compressed-01.jpg'
import img2 from '../assets/issue_7/RM007_COVER1_FORPRINT_compressed-02.jpg'
import img3 from '../assets/issue_7/RM007_COVER1_FORPRINT_compressed-03.jpg'
import img4 from '../assets/issue_7/RM007_COVER1_FORPRINT_compressed-04.jpg'
import img5 from '../assets/issue_7/RM007_COVER1_FORPRINT_compressed-05.jpg'
import img6 from '../assets/issue_7/RM007_COVER1_FORPRINT_compressed-06.jpg'
import img7 from '../assets/issue_7/RM007_COVER1_FORPRINT_compressed-07.jpg'
import img8 from '../assets/issue_7/RM007_COVER1_FORPRINT_compressed-08.jpg'
import img9 from '../assets/issue_7/RM007_COVER1_FORPRINT_compressed-09.jpg'
import img10 from '../assets/issue_7/RM007_COVER1_FORPRINT_compressed-10.jpg'
import img11 from '../assets/issue_7/RM007_COVER1_FORPRINT_compressed-11.jpg'
import img12 from '../assets/issue_7/RM007_COVER1_FORPRINT_compressed-12.jpg'
import img13 from '../assets/issue_7/RM007_COVER1_FORPRINT_compressed-13.jpg'
import img14 from '../assets/issue_7/RM007_COVER1_FORPRINT_compressed-14.jpg'
import img15 from '../assets/issue_7/RM007_COVER1_FORPRINT_compressed-15.jpg'
import img16 from '../assets/issue_7/RM007_COVER1_FORPRINT_compressed-16.jpg'
import img17 from '../assets/issue_7/RM007_COVER1_FORPRINT_compressed-17.jpg'
import img18 from '../assets/issue_7/RM007_COVER1_FORPRINT_compressed-18.jpg'
import img19 from '../assets/issue_7/RM007_COVER1_FORPRINT_compressed-19.jpg'
import img20 from '../assets/issue_7/RM007_COVER1_FORPRINT_compressed-20.jpg'
import img21 from '../assets/issue_7/RM007_COVER1_FORPRINT_compressed-21.jpg'
import img22 from '../assets/issue_7/RM007_COVER1_FORPRINT_compressed-22.jpg'
import img23 from '../assets/issue_7/RM007_COVER1_FORPRINT_compressed-23.jpg'

export default class Mag007 extends Component {
  render() {
    return (
      <div className="image-container">
        <img src={img1} className="image"></img>
        <img src={img2} className="image"></img>
        <img src={img3} className="image"></img>
        <img src={img4} className="image"></img>
        <img src={img5} className="image"></img>
        <img src={img6} className="image"></img>
        <img src={img7} className="image"></img>
        <img src={img8} className="image"></img>
        <img src={img9} className="image"></img>
        <img src={img10} className="image"></img>
        <img src={img11} className="image"></img>
        <img src={img12} className="image"></img>
        <img src={img13} className="image"></img>
        <img src={img14} className="image"></img>
        <img src={img15} className="image"></img>
        <img src={img16} className="image"></img>
        <img src={img17} className="image"></img>
        <img src={img18} className="image"></img>
        <img src={img19} className="image"></img>
        <img src={img20} className="image"></img>
        <img src={img21} className="image"></img>
        <img src={img22} className="image"></img>
        <img src={img23} className="image"></img>
      </div>
    )
  }
}
